import React, { FC, useEffect, useState } from "react";
import TickAnimationIconSvg from "@app/neva/assets/svg/tick-animation-icon.svg";
import Svg from "@natera/material/lib/svg";
import "./successScreen.scss";
import classNames from "classnames";

const SHOW_ANIMATION_DELAY_TIMEOUT = 120;
const FINISH_ANIMATION_DELAY_TIMEOUT = 2200;

interface Props {
  handleCloseModal: () => void;
}

export const SuccessScreen: FC<Props> = ({ handleCloseModal }) => {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    const animationDelay = setTimeout(
      () => setShowAnimation(true),
      SHOW_ANIMATION_DELAY_TIMEOUT
    );
    const closeDelay = setTimeout(
      () => handleFinishAnimation(),
      FINISH_ANIMATION_DELAY_TIMEOUT
    );
    return () => {
      clearTimeout(animationDelay);
      clearTimeout(closeDelay);
    };
  }, []);

  const handleFinishAnimation = () => {
    handleCloseModal();
  };

  return (
    <div
      className={classNames("success-screen", {
        "success-screen--drawn": showAnimation,
      })}
      data-testid="success-container"
    >
      <Svg
        className="success-screen__icon"
        content={TickAnimationIconSvg}
        role="img"
      />
    </div>
  );
};

export default SuccessScreen;
